import BaseService from './../base'

export default class AuthoritiesService extends BaseService {
  static resource() {
    return 'api/v1/external/authorities'
  }
}
